var _rect, _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    fill: "#4D6CD9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 900
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    fill: "#4D6CD9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1105 1093C1324.26 1093 1502 915.257 1502 696C1502 476.743 1324.26 299 1105 299C885.743 299 708 476.743 708 696C708 915.257 885.743 1093 1105 1093ZM1105 911C1223.74 911 1320 814.741 1320 696C1320 577.259 1223.74 481 1105 481C986.259 481 890 577.259 890 696C890 814.741 986.259 911 1105 911Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 899.368,
    cy: 65.3684,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 899.368,
    cy: 97.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 899.368,
    cy: 129.789,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 899.368,
    cy: 162,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 899.368,
    cy: 194.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 899.368,
    cy: 226.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 899.368,
    cy: 258.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 931.579,
    cy: 65.3684,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 931.579,
    cy: 97.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 931.579,
    cy: 129.789,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 931.579,
    cy: 162,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 931.579,
    cy: 194.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 931.579,
    cy: 226.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 931.579,
    cy: 258.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 963.789,
    cy: 65.3684,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 963.789,
    cy: 97.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 963.789,
    cy: 129.789,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 963.789,
    cy: 162,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 963.789,
    cy: 194.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 963.789,
    cy: 226.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 963.789,
    cy: 258.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996,
    cy: 65.3684,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996,
    cy: 97.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996,
    cy: 129.789,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996,
    cy: 162,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996,
    cy: 194.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996,
    cy: 226.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 996,
    cy: 258.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.21,
    cy: 65.3684,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.21,
    cy: 97.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.21,
    cy: 129.789,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.21,
    cy: 162,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.21,
    cy: 194.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.21,
    cy: 226.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028.21,
    cy: 258.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060.42,
    cy: 65.3684,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060.42,
    cy: 97.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060.42,
    cy: 129.789,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060.42,
    cy: 162,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060.42,
    cy: 194.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060.42,
    cy: 226.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1060.42,
    cy: 258.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1092.63,
    cy: 65.3684,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1092.63,
    cy: 97.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1092.63,
    cy: 129.789,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1092.63,
    cy: 162,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1092.63,
    cy: 194.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1092.63,
    cy: 226.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1092.63,
    cy: 258.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1124.84,
    cy: 65.3684,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1124.84,
    cy: 97.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1124.84,
    cy: 129.789,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1124.84,
    cy: 162,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1124.84,
    cy: 194.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1124.84,
    cy: 226.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1124.84,
    cy: 258.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1157.05,
    cy: 65.3684,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1157.05,
    cy: 97.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1157.05,
    cy: 129.789,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1157.05,
    cy: 162,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1157.05,
    cy: 194.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1157.05,
    cy: 226.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1157.05,
    cy: 258.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1189.26,
    cy: 65.3684,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1189.26,
    cy: 97.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1189.26,
    cy: 129.789,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1189.26,
    cy: 162,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1189.26,
    cy: 194.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1189.26,
    cy: 226.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1189.26,
    cy: 258.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126 422C297.208 422 436 283.208 436 112C436 -59.2083 297.208 -198 126 -198C-45.2083 -198 -184 -59.2083 -184 112C-184 283.208 -45.2083 422 126 422ZM126 304C232.039 304 318 218.039 318 112C318 5.96133 232.039 -80 126 -80C19.9613 -80 -66 5.96133 -66 112C-66 218.039 19.9613 304 126 304Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.368,
    cy: 645.368,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.368,
    cy: 677.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.368,
    cy: 709.79,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.368,
    cy: 742,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.368,
    cy: 774.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.368,
    cy: 806.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.368,
    cy: 838.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.579,
    cy: 645.368,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.579,
    cy: 677.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.579,
    cy: 709.79,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.579,
    cy: 742,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.579,
    cy: 774.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.579,
    cy: 806.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172.579,
    cy: 838.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.789,
    cy: 645.368,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.789,
    cy: 677.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.789,
    cy: 709.79,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.789,
    cy: 742,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.789,
    cy: 774.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.789,
    cy: 806.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.789,
    cy: 838.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 645.368,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 677.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 709.79,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 742,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 774.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 806.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 838.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.211,
    cy: 645.368,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.211,
    cy: 677.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.211,
    cy: 709.79,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.211,
    cy: 742,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.211,
    cy: 774.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.211,
    cy: 806.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.211,
    cy: 838.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.421,
    cy: 645.368,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.421,
    cy: 677.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.421,
    cy: 709.79,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.421,
    cy: 742,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.421,
    cy: 774.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.421,
    cy: 806.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.421,
    cy: 838.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.632,
    cy: 645.368,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.632,
    cy: 677.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.632,
    cy: 709.79,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.632,
    cy: 742,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.632,
    cy: 774.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.632,
    cy: 806.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.632,
    cy: 838.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.842,
    cy: 645.368,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.842,
    cy: 677.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.842,
    cy: 709.79,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.842,
    cy: 742,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.842,
    cy: 774.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.842,
    cy: 806.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365.842,
    cy: 838.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.052,
    cy: 645.368,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.052,
    cy: 677.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.052,
    cy: 709.79,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.052,
    cy: 742,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.052,
    cy: 774.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.052,
    cy: 806.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.052,
    cy: 838.632,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.263,
    cy: 645.368,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.263,
    cy: 677.579,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.263,
    cy: 709.79,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.263,
    cy: 742,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.263,
    cy: 774.21,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.263,
    cy: 806.421,
    r: 5.36842,
    fill: "#5C78DC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.263,
    cy: 838.632,
    r: 5.36842,
    fill: "#5C78DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1121.65,
    y1: 443.713,
    x2: 1105,
    y2: 1093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D6CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A85E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 139,
    y1: -85,
    x2: 126,
    y2: 422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D6CD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A85E5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.04a9de4f589b4d21be003b55f5d82a2c.svg";
export { ForwardRef as ReactComponent };